import { z } from "zod";

export interface LdoPaginated<T> {
  total: number;
  items: T[];
  limit: number | null;
  offset: number | null;
}

export function paginatedSchema(listItemSchema: z.Schema) {
  return z.object({
    total: z.number(),
    items: z.array(listItemSchema),
    limit: z.number().nullable(),
    offset: z.number().nullable(),
  });
}
